export default __webpack_public_path__ + "static/027-209556f06c1b8cacb980b0e2499faadf.png";